exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: \"avantgardelt-extralight\", arial;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: \"avantgardelt-extralight\", arial;\n}\n\nhtml, body { \n  height: 100%; \n  min-height: 100%;\n}\n\n#root{\n  height: inherit;\n}", ""]);

// exports
